import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { getCurrentUser } from "@services/api/authentication/currentUser";
import type { UserData } from "@services/api/authentication/currentUser/interface";
import { AuthContext } from "@services/authentication/auth.context";
import { LOGOUT_PATH } from "@routes/path";

type AuthStatus = "checking" | "authenticated" | "unauthenticated";

export function ProtectedLayout() {
  
  const location = useLocation();
  const [authStatus, setAuthStatus] = useState<AuthStatus>("checking");
  const [user, setUser] = useState<UserData | null>(null);

  useEffect(() => {

    void getCurrentUser()
      .then((profile) => {
          setUser(profile);
          setAuthStatus("authenticated");   
      })
      .catch(() => {
          setUser(null);
          setAuthStatus("unauthenticated");
      });
  }, []);

  if (authStatus === "checking") {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center"
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (authStatus === "unauthenticated" || !user) {
    return (
      <Navigate
        to={LOGOUT_PATH}
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  return (
    
      <AuthContext.Provider value={{ user }}>
        
          {/* {(!user?.role || user?.role == "customer") && ![CONTACT_VERIFICATION_PATH].includes(location.pathname) && (
            <CartFloatingContainer />
          )} */}
          <Outlet />
      </AuthContext.Provider>
  );
}
